import styles from './MobileBottomModal.module.scss';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';
import ClickAwayListener from 'react-click-away-listener';

interface MobileBottomModalProps extends PropsWithChildren {
    className?: string;
    onClickAway: () => void;
}

export const MobileBottomModal: FunctionComponent<MobileBottomModalProps> = props => {
    return (
        <div className={styles.backdrop}>
            <ClickAwayListener onClickAway={props.onClickAway}>
                <div className={clsx(styles.container, props.className)}>
                    <div className={styles.header}>
                        <div className={styles.handle} />
                    </div>
                    {props.children}
                </div>
            </ClickAwayListener>
        </div>
    );
};

export default MobileBottomModal;
